import React from "react";
import { Link } from "react-router-dom";

export function StepsTracing() {

    
  return (
      <div className=" mx-auto antialiased pt-4 md:ml-5 relative">
      <div className="max-w-7xl mx-auto flex flex-col jus gap-10  px-2" id="tutorial">
    <h2 className=" md:text-3xl text-2xl font-serif text-dark-200 font-bold text-center pb-5 md:py-20 ">Unsere Vermarktungsleistungen</h2>
    <section className="flex flex-col md:flex-row gap-10 pb-10 justify-items-center " id="step1">
      <div className="md:w-1/2">
        <img className="object-cover   md:translate-x-0 rounded-lg " src="/Fotos/verkaufen-leistungen-fotos-jakobs.png" alt="" />
      </div>
      <div className=" md:w-6/12">
        <div>
            <p className="opacity-70 hidden text-bd3 font-medium">Schritt 1</p>
            <h3 className=" text-2xl font-serif text-dark-100 md:text-h3 text-mwb font-semibold before:bg-mwo2 relative z-[1] before:z-[-1] before:opacity-80 before:absolute before:left-0 before:bottom-0 before:h-3 before:w-fit">Weil der erste Eindruck zählt</h3>
        </div>
        <p className="pt-3 lg:text-lg text  font-normal text-gray-600 leading-normal font-['Inter']">Präsentieren Sie Ihre Immobilie im besten Licht – mit hochwertigen Aufnahmen die Interesse wecken und verkaufen. Wie genau wir Ihre Immobilie optimal in Szene setzen, besprechen wir gerne persönlich – vereinbaren Sie jetzt einen <Link to={"/beratungstermin"} className="underline text-prime-700">unverbindlichen Beratungstermin</Link>.</p>
      </div>
    </section>
    <section className="flex flex-col gap-10  md:flex-row-reverse py-10" id="step2">
      <div className="md:w-1/2">
      <img className="object-cover   md:translate-x-0 rounded-lg " src="/Fotos/verkaufen-leistungen-360-jakobs.png" alt="" />

      </div>
      <div className="md:w-6/12">
      <div>
            <p className="opacity-70 hidden text-bd3 font-medium">Schritt 2</p>
            <h3 className=" text-2xl font-serif text-dark-100 md:text-h3 text-mwb font-semibold before:bg-mwo2 relative z-[1] before:z-[-1] before:opacity-80 before:absolute before:left-0 before:bottom-0 before:h-3 before:w-fit">Ihre Immobilie hautnah erleben</h3>
        </div>        <p className="pt-3 lg:text-lg text  font-normal text-gray-600 leading-relaxed font-['Inter']">Mit moderner 360°-Kameratechnologie öffnen wir Türen – schon vor dem ersten Besuch. So erhalten Kaufinteressenten einen realistischen Eindruck Ihrer Immobilie – ortsunabhängig und zeitsparend. Wie wir Ihre Vermarktung individuell gestalten, zeigen wir Ihnen gerne in einem<Link to={"/beratungstermin"} className="underline text-prime-700"> persönlichen Beratungstermin</Link>.</p>
      </div>
    </section>
    <section className="flex flex-col md:flex-row gap-10  justify-items-center py-10" id="step3">
      <div className="md:w-1/2">
      <img className="object-cover   md:translate-x-0 rounded-lg " src="/Fotos/verkaufen-leistungen-drohne-jakobs.png" alt="" />

      </div>
      <div className="md:w-6/12">
      <div>
            <p className="opacity-70 hidden text-bd3 font-medium">Schritt 3</p>
            <h3 className=" text-2xl font-serif text-dark-100 md:text-h3 text-mwb font-semibold before:bg-mwo2 relative z-[1] before:z-[-1] before:opacity-80 before:absolute before:left-0 before:bottom-0 before:h-3 before:w-fit">Beeindruckende Perspektiven</h3>
        </div>        <p className="pt-3 lg:text-lg text  font-normal text-gray-600 leading-relaxed font-['Inter']">Professionelle Drohnenaufnahmen zeigen Größe, Lage und Umgebung Ihrer Immobilie eindrucksvoll – und machen sie für Käufer auf den ersten Blick besonders. Gerne <Link to={"/beratungstermin"} className="underline text-prime-700">beraten wir Sie kostenlos</Link>, wie wir auch Ihre Immobilie aus der Luft wirkungsvoll in Szene setzen können.

          </p>
      </div>
    </section>

  
  </div>
      </div>
  );
}

